export const overlayCss = `
  [data-fg-debug] {
    position: fixed;
    top: 8px;
    right: 8px;
    z-index: 2147483647;
    padding: 8px 10px;
    background: rgba(0, 0, 0, 0.72);
    color: #d1d5db;
    font: 11px/1.4 ui-monospace, SF Mono, Menlo, monospace;
    border-radius: 6px;
    max-width: 280px;
    min-width: 180px;
    pointer-events: none;
  }
  [data-fg-debug] section { margin: 0 0 6px; }
  [data-fg-debug] [data-metric] { display: flex; justify-content: space-between; gap: 8px; }
  [data-fg-debug] [data-metric] strong { color: #fff; font-weight: 600; }
  [data-fg-debug] [data-log] {
    border-top: 1px solid rgba(255,255,255,0.15);
    padding-top: 6px;
    margin-top: 6px;
    max-height: 140px;
    overflow: hidden;
  }
  [data-fg-debug] [data-log-row] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    opacity: 0.85;
  }
`;
